import $ from 'jquery';
import axios from "axios";
import Cookie from 'js-cookie';

const selectors = {
  header: '.header-wrapper',
  fixedElement: '.header',
  hideOnFixed: '.announcement-bar',
  collectionsBar: '.collections_bar',
  mainContent: '#MainContent',
  filter: '.filter-wrapper',
  filterMobile: '.bc-sf-filter-custom-sorting-mobile',
  filterDesktop: '.bc-sf-filter-left-col'
};

const classes = {
  fixed: 'fixed-top',
  bottom: 'bottom',
  visuallyHidden: 'visually-hidden-slick' // So sliders don't need to be reinitialised
};

let headerHeight, threshold, addMarginTo;

function getVisibleHeight(selector) {
  const $element = $(selector).first();

  if (!$element.length || !$element.is(':visible')) {
    return 0;
  }

  return $element.outerHeight() || 0;
}

function reset() {
  $(selectors.header).removeClass(classes.fixed);
  $(selectors.filter).removeClass(classes.fixed);
  $(selectors.filterMobile).removeClass(classes.fixed);
  $(selectors.hideOnFixed).removeClass(classes.visuallyHidden);
  addMarginTo.css("margin-top", 0);
  $(selectors.filter).css("margin-top", 0);
  $(selectors.filterMobile).css("margin-top", 0);
}

function resetFilterDesktop() {
  $(selectors.filterDesktop).removeClass(classes.fixed);
  $(selectors.filterDesktop).css("top", "initial");
}

function setValues() {
  if (addMarginTo) {
    reset();
  }

  headerHeight = $(selectors.header).height();
  addMarginTo = $(selectors.mainContent);
  threshold = $(selectors.fixedElement).offset().top;
};

function handleScroll() {
  let currentPosition = $(document).scrollTop();
  let footerPosition = $('#shopify-section-footer').offset().top;
  if (currentPosition >= threshold + 102) {
    $(selectors.filterDesktop).addClass(classes.fixed);
    $(selectors.filterDesktop).removeClass(classes.bottom);
    $(selectors.filterDesktop).css("top", headerHeight);
  } else {
    resetFilterDesktop();
  }
  if(!document.body.classList.contains('noscroll')) {
    if (currentPosition >= threshold) {
      if (!$(selectors.header).hasClass(classes.fixed)) {
        const fullBeforeHide = $(selectors.header).outerHeight();

        $(selectors.header).addClass(classes.fixed);
        $(selectors.filter).addClass(classes.fixed);
        $(selectors.filterMobile).addClass(classes.fixed);
        $(selectors.hideOnFixed).addClass(classes.visuallyHidden);
        const socialsHeight = getVisibleHeight('.header__socials-mobile');
        const collectionsBarHeight = getVisibleHeight(selectors.collectionsBar);
        addMarginTo.css("margin-top", Math.max(0, fullBeforeHide - socialsHeight - collectionsBarHeight));
        $(selectors.filterDesktop).css("top", $(selectors.header).height() - $('.announcement-bar').height());
        $(selectors.filterMobile).css("margin-top", $(selectors.header).height() + $(selectors.filter).height());
        $(selectors.filterDesktop).css("max-height", $(window).height() - headerHeight);
        $(selectors.filter).css("margin-top", $(selectors.header).height());
      }
      if (currentPosition + $(selectors.filterDesktop).height() + headerHeight > footerPosition ) {
        $(selectors.filterDesktop).removeClass(classes.fixed);
        $(selectors.filterDesktop).addClass(classes.bottom);
        $(selectors.filterDesktop).css("top", "initial");
      }
    } else {
      reset();
    }
  }
};

(function() {

  setValues();
  handleScroll();


  $(window).scroll(function () {
    handleScroll();
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const __header = document.getElementById("shopify-section-header");
  const searchHeader = document.getElementById("search-header");
  const submitButton = document.getElementById("submit-button");

  document.getElementById("submit-button").addEventListener("click", (e) => {

    // Stop the click event from bubbling up to the outer event listener
    e.preventDefault();
    e.stopPropagation();

    if (searchHeader.classList.contains("focus")) {
      searchHeader.classList.remove("focus");
      submitButton.classList.remove("focus");
    } else {
      searchHeader.classList.add("focus");
      submitButton.classList.add("focus");
      searchHeader.focus();
    }
  });
  
  document.addEventListener("click", function(e) {
    if (__header && !__header.contains(e.target)) {
      searchHeader.classList.remove("focus");
      submitButton.classList.remove("focus");
    }
  });

});

// Warning: I commented this out to stop some weird behaviour where the filters on collection pages kept changing position. However, I have no idea what it was for. 

// const countdownObserver = new MutationObserver((mutations) => {
//   // setValues();
//   // handleScroll();
// });
// const obsConfig = { subtree: true, childList: true };
// const countdown = document.querySelector('.countdown');
// if (countdown) {
//   countdownObserver.observe(document.querySelector('.countdown'), obsConfig);  
// }
